/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  ListQueryImagesParams,
  QueryImageCompleteUploadRequest,
  QueryImageCompleteUploadResponse,
  QueryImageDeleteRequest,
  QueryImageDeleteResponse,
  QueryImageListResponse,
  QueryImageStartUploadRequest,
  QueryImageStartUploadResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListQueryImagesHook = () => {
        const listQueryImages = useCustomInstance<QueryImageListResponse>();

        return useCallback((
    params?: ListQueryImagesParams,
 signal?: AbortSignal
) => {
        return listQueryImages(
          {url: `/QueryImage/List`, method: 'GET',
        params, signal
    },
          );
        }, [listQueryImages])
      }
    

export const getListQueryImagesQueryKey = (params?: ListQueryImagesParams,) => {
    return [`/QueryImage/List`, ...(params ? [params]: [])] as const;
    }

    
export const useListQueryImagesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError = unknown>(params?: ListQueryImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListQueryImagesQueryKey(params);

  const listQueryImages =  useListQueryImagesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>> = ({ signal }) => listQueryImages(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListQueryImagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>>
export type ListQueryImagesQueryError = unknown


export function useListQueryImages<TData = Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError = unknown>(
 params: undefined |  ListQueryImagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQueryImages<TData = Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError = unknown>(
 params?: ListQueryImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListQueryImages<TData = Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError = unknown>(
 params?: ListQueryImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListQueryImages<TData = Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError = unknown>(
 params?: ListQueryImagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListQueryImagesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListQueryImagesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useStartQueryImageUploadHook = () => {
        const startQueryImageUpload = useCustomInstance<QueryImageStartUploadResponse>();

        return useCallback((
    queryImageStartUploadRequest: QueryImageStartUploadRequest,
 signal?: AbortSignal
) => {
        return startQueryImageUpload(
          {url: `/QueryImage/StartUpload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queryImageStartUploadRequest, signal
    },
          );
        }, [startQueryImageUpload])
      }
    


export const useStartQueryImageUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>, TError,{data: QueryImageStartUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>, TError,{data: QueryImageStartUploadRequest}, TContext> => {

const mutationKey = ['startQueryImageUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const startQueryImageUpload =  useStartQueryImageUploadHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>, {data: QueryImageStartUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  startQueryImageUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StartQueryImageUploadMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>>
    export type StartQueryImageUploadMutationBody = QueryImageStartUploadRequest
    export type StartQueryImageUploadMutationError = unknown

    export const useStartQueryImageUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>, TError,{data: QueryImageStartUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useStartQueryImageUploadHook>>>,
        TError,
        {data: QueryImageStartUploadRequest},
        TContext
      > => {

      const mutationOptions = useStartQueryImageUploadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useCompleteQueryImageUploadHook = () => {
        const completeQueryImageUpload = useCustomInstance<QueryImageCompleteUploadResponse>();

        return useCallback((
    queryImageCompleteUploadRequest: QueryImageCompleteUploadRequest,
 signal?: AbortSignal
) => {
        return completeQueryImageUpload(
          {url: `/QueryImage/CompleteUpload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: queryImageCompleteUploadRequest, signal
    },
          );
        }, [completeQueryImageUpload])
      }
    


export const useCompleteQueryImageUploadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>, TError,{data: QueryImageCompleteUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>, TError,{data: QueryImageCompleteUploadRequest}, TContext> => {

const mutationKey = ['completeQueryImageUpload'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const completeQueryImageUpload =  useCompleteQueryImageUploadHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>, {data: QueryImageCompleteUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  completeQueryImageUpload(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteQueryImageUploadMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>>
    export type CompleteQueryImageUploadMutationBody = QueryImageCompleteUploadRequest
    export type CompleteQueryImageUploadMutationError = unknown

    export const useCompleteQueryImageUpload = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>, TError,{data: QueryImageCompleteUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCompleteQueryImageUploadHook>>>,
        TError,
        {data: QueryImageCompleteUploadRequest},
        TContext
      > => {

      const mutationOptions = useCompleteQueryImageUploadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteQueryImageHook = () => {
        const deleteQueryImage = useCustomInstance<QueryImageDeleteResponse>();

        return useCallback((
    queryImageDeleteRequest: QueryImageDeleteRequest,
 ) => {
        return deleteQueryImage(
          {url: `/QueryImage/Delete`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: queryImageDeleteRequest
    },
          );
        }, [deleteQueryImage])
      }
    


export const useDeleteQueryImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>, TError,{data: QueryImageDeleteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>, TError,{data: QueryImageDeleteRequest}, TContext> => {

const mutationKey = ['deleteQueryImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteQueryImage =  useDeleteQueryImageHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>, {data: QueryImageDeleteRequest}> = (props) => {
          const {data} = props ?? {};

          return  deleteQueryImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteQueryImageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>>
    export type DeleteQueryImageMutationBody = QueryImageDeleteRequest
    export type DeleteQueryImageMutationError = unknown

    export const useDeleteQueryImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>, TError,{data: QueryImageDeleteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteQueryImageHook>>>,
        TError,
        {data: QueryImageDeleteRequest},
        TContext
      > => {

      const mutationOptions = useDeleteQueryImageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    